@if (shouldShow) {
  <div class="verification-banner">
    {{ message }}
    @if (showVerificationLink) {
      <a [href]="verificationUrl">Complete your Identity Verification</a>
    }
  </div>
}
